import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { getFormValues } from 'redux-form';

import VMSFormComponent from '../components/VMSFormComponent';

import { showConfirmModal } from '../../Modal/actions';

const form = 'VisitorKeys';
const VMSFormContainer = (props) => {
  const {
    formValues,
    buildingsID,
    building,
    putVisitorKeysData,
    showModal,
    residentCanAddVisitors,
    residentCanSendKey,
    residentMaxSentKeys,
    residentValidUntilLimitEnabled,
    residentValidUntilLimitDays,
    staffMaxSentKeys,
    visitorPhotoRequired,
    createCameraSnapshotOnVisitor,
  } = props;

  const onSubmitVMS = (data, onSaveChangesUserMade = true) => {
    const localData = formValues;
    const id = building;
    if (!data.buildings) {
      localData.buildings = [`${id}`];
    }
    putVisitorKeysData(localData, onSaveChangesUserMade);
  };

  const copySettingsToAll = () => {
    const data = formValues;
    data.buildings = buildingsID;
    onSubmitVMS(data, false);
  };

  const VMSShowModal = () =>
    showModal({
      bodyText:
        'Copying these settings will override the settings for all buildings',
      confirmText: 'Copy',
      onConfirm: copySettingsToAll,
      cancelText: 'Cancel',
    });

  const shouldDisplayCopyToAll = buildingsID && buildingsID.length > 1;
  const VMSProps = {
    shouldDisplayCopyToAll,
    form,
    initialValues: {
      residentCanAddVisitors,
      residentCanSendKey,
      residentMaxSentKeys,
      residentValidUntilLimitEnabled,
      residentValidUntilLimitDays,
      staffMaxSentKeys,
      notifyPM: true,
      visitorPhotoRequired,
      createCameraSnapshotOnVisitor,
    },
    formState: formValues,
    building,
    onSubmit: onSubmitVMS,
    enableReinitialize: true,
    destroyOnUnmount: false,
    showModal: VMSShowModal,
  };
  return <VMSFormComponent {...VMSProps} />;
};
const mapStateToProps = (state) => ({
  formValues: getFormValues(form)(state),
});

const mapDispatchToProps = (dispatch) => ({
  showModal: (modalProps) => showConfirmModal(dispatch, modalProps),
});

VMSFormContainer.defaultProps = {
  building: null,
  residentCanSendKey: null,
  residentMaxSentKeys: null,
  residentValidUntilLimitEnabled: null,
  residentValidUntilLimitDays: null,
  staffMaxSentKeys: null,
  visitorPhotoRequired: null,
  createCameraSnapshotOnVisitor: null,
  formValues: {},
};

VMSFormContainer.propTypes = {
  formValues: PropTypes.instanceOf(Object),
  buildingsID: PropTypes.instanceOf(Array).isRequired,
  building: PropTypes.number,
  putVisitorKeysData: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  residentCanSendKey: PropTypes.bool,
  residentMaxSentKeys: PropTypes.number,
  residentCanAddVisitors: PropTypes.bool,
  residentValidUntilLimitEnabled: PropTypes.bool,
  residentValidUntilLimitDays: PropTypes.number,
  staffMaxSentKeys: PropTypes.number,
  visitorPhotoRequired: PropTypes.bool,
  createCameraSnapshotOnVisitor: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(VMSFormContainer);
